import { supabase } from './supabase';

/**
 * Upload des photos produits vers Supabase Storage (bucket public `product-images`).
 * Le resto choisit un fichier dans l'éditeur → on l'envoie ici et on récupère l'URL
 * publique à stocker dans `products.image_url`. Le champ « URL collée » reste en repli.
 *
 * Bucket attendu (à créer une fois par Ahmed) : `product-images`, public en lecture.
 */
export const PRODUCT_IMAGES_BUCKET = 'product-images';

/** Translittère un nom de fichier en segment d'URL sûr (sans accents/espaces). */
export function safeFileName(name: string): string {
  const dot = name.lastIndexOf('.');
  const ext = dot > 0 ? name.slice(dot + 1).toLowerCase().replace(/[^a-z0-9]/g, '') : '';
  const base = (dot > 0 ? name.slice(0, dot) : name)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40) || 'photo';
  return ext ? `${base}.${ext}` : base;
}

/** Chemin de stockage : isolé par tenant + horodaté pour éviter les collisions. */
export function storagePath(tenantId: string, fileName: string, now: number = Date.now()): string {
  return `${tenantId}/${now}-${safeFileName(fileName)}`;
}

/**
 * Envoie un fichier image et renvoie son URL publique (ou null en cas d'échec).
 * Tolérant aux erreurs (log) pour ne jamais casser l'UI de l'éditeur.
 */
export async function uploadProductImage(
  tenantId: string,
  file: File,
): Promise<string | null> {
  const path = storagePath(tenantId, file.name);
  const { error } = await supabase.storage
    .from(PRODUCT_IMAGES_BUCKET)
    .upload(path, file, { cacheControl: '3600', upsert: false });
  if (error) {
    console.warn('[storage] upload échoué:', error.message);
    return null;
  }
  const { data } = supabase.storage.from(PRODUCT_IMAGES_BUCKET).getPublicUrl(path);
  return data?.publicUrl ?? null;
}
